import { LAYOUT_ALGORITHM } from "Common/dictionaries/layoutAlgorithm";
import CircularLayoutConfig from "./circularLayoutConfig";
import HierarchicLayoutConfig from "./hierarchicLayoutConfig";
import OrganicLayoutConfig from "./organicLayoutConfig";
import OrthogonalLayoutConfig from "./orthogonalLayoutConfig";
import TreeLayoutConfig from "./treeLayoutConfig";
export default {
    [LAYOUT_ALGORITHM.HIERARCHIC]: () => new HierarchicLayoutConfig(),
    [LAYOUT_ALGORITHM.TREE]: () => new TreeLayoutConfig(),
    [LAYOUT_ALGORITHM.ORGANIC]: () => new OrganicLayoutConfig(),
    [LAYOUT_ALGORITHM.ORTHOGONAL]: () => new OrthogonalLayoutConfig(),
    [LAYOUT_ALGORITHM.CIRCULAR]: () => new CircularLayoutConfig()
};
